"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FireTest = void 0;
var FC = require("./fire_constants");
var FU = require("./fire_util");
var FireTest = (function () {
    function FireTest(db, collection, doc, getTest, setTest) {
        this.db = db;
        this.collection = collection;
        this.doc = doc;
        this.getTest = getTest;
        this.setTest = setTest;
        this.update = true;
        this.countTests = 0;
        this.preparedTests = [];
    }
    FireTest.prototype.getData = function () {
        return this._data;
    };
    FireTest.prototype.currentTest = function () {
        return this.preparedTests[this.countTests];
    };
    FireTest.prototype.prepareTests = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, key, test_1;
            var e_1, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this;
                        return [4, FU.downloadData(this.db, this.collection, this.doc)];
                    case 1:
                        _a._data = _e.sent();
                        this.order = this._data.order;
                        this.tests = this._data.tests;
                        try {
                            for (_b = __values(this.order), _c = _b.next(); !_c.done; _c = _b.next()) {
                                key = _c.value;
                                test_1 = this.tests[key];
                                test_1.brf = '';
                                test_1.unicode = '';
                                this.preparedTests.push(test_1);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2];
                }
            });
        });
    };
    FireTest.prototype.saveTest = function (values) {
        return __awaiter(this, void 0, void 0, function () {
            var test, status, _a, _b, key;
            var e_2, _c;
            return __generator(this, function (_d) {
                test = this.currentTest();
                status = null;
                try {
                    for (_a = __values(Object.keys(values)), _b = _a.next(); !_b.done; _b = _a.next()) {
                        key = _b.value;
                        if (test[key] !== values[key]) {
                            status = 2;
                        }
                        test[key] = values[key];
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                if (status === 2) {
                    test[FC.Interaction] = status;
                    if (this.update) {
                        FU.updateData(this.db, this.collection, this.doc, test, ['tests', test.name]);
                    }
                }
                if (!status && !test[FC.Interaction]) {
                    test[FC.Interaction] = 1;
                    if (this.update) {
                        FU.updateData(this.db, this.collection, this.doc, test[FC.Interaction], ['tests', test.name, FC.Interaction]);
                    }
                }
                return [2];
            });
        });
    };
    FireTest.prototype.saveFeedback = function (feedback) {
        return __awaiter(this, void 0, void 0, function () {
            var test;
            return __generator(this, function (_a) {
                test = this.currentTest();
                FU.updateData(this.db, this.collection, this.doc, feedback, ['tests', test.name, FC.FeedbackStatus]);
                return [2];
            });
        });
    };
    FireTest.prototype.cycleTests = function (direction) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.saveTest(this.getTest())];
                    case 1:
                        _a.sent();
                        this.setTest(this.nextTest(direction));
                        return [2];
                }
            });
        });
    };
    FireTest.prototype.cycleUnchangedTests = function (direction) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.saveTest(this.getTest())];
                    case 1:
                        _a.sent();
                        this.setTest(this.jumpTest(direction, function (x) { return x !== 2; }));
                        return [2];
                }
            });
        });
    };
    FireTest.prototype.cycleNewTests = function (direction) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.saveTest(this.getTest())];
                    case 1:
                        _a.sent();
                        this.setTest(this.jumpTest(direction, function (x) { return x === 0; }));
                        return [2];
                }
            });
        });
    };
    FireTest.prototype.goTest = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var index;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.saveTest(this.getTest())];
                    case 1:
                        _a.sent();
                        index = this.order.indexOf(name);
                        if (index === -1) {
                            return [2];
                        }
                        this.countTests = index;
                        this.setTest(this.currentTest());
                        return [2];
                }
            });
        });
    };
    FireTest.prototype.nextTest = function (direction) {
        this.countTests = this.countTests + (direction ? 1 : -1);
        if (this.countTests < 0) {
            this.countTests = this.preparedTests.length - 1;
        }
        if (this.countTests >= this.preparedTests.length) {
            this.countTests = 0;
        }
        return this.currentTest();
    };
    FireTest.prototype.jumpTest = function (direction, stop) {
        var currentCount = this.countTests;
        while (!stop(this.nextTest(direction)[FC.Interaction]) &&
            this.countTests !== currentCount) { }
        return currentCount !== this.countTests ? this.currentTest() :
            this.nextTest(direction);
    };
    return FireTest;
}());
exports.FireTest = FireTest;
